import { createContext, useContext } from "react";

import type { TrackerCategory } from "../../../common/tracking/trackerService";

interface NotificationContextValue {
  onRequestClose?: () => void;
  trackerCategory: TrackerCategory;
}

const NotificationContext = createContext<NotificationContextValue | null>(
  null,
);

export const NotificationContextProvider = NotificationContext.Provider;

export const useNotificationContext = (): NotificationContextValue => {
  const value = useContext(NotificationContext);
  if (!value) {
    throw new Error(
      "useNotificationContext must be used within a NotificationContextProvider",
    );
  }
  return value;
};
